// extracted by css-extract-rspack-plugin
export default {"logo":"logo-Dg11y7","avatar":"avatar-LBAnvj"};